import { Box, Button, Typography } from '@mui/material';
import { useAuth } from './authContext';
import { stopImpersonation } from './impersonation';
import { leaveGuarded } from './leaveGuard';

const FONT = '"Nunito Sans", "Helvetica", "Arial", sans-serif';

export function ImpersonationBanner() {
  const { impersonation } = useAuth();
  if (!impersonation) return null;
  const who = impersonation.districtName
    ? `${impersonation.email} (${impersonation.districtName})`
    : impersonation.email;
  return (
    <Box
      data-testid="impersonation-banner"
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
        py: 1,
        bgcolor: '#B3261E',
        color: '#FFFFFF',
      }}
    >
      <Typography sx={{ fontFamily: FONT, fontSize: 14, fontWeight: 600 }}>
        Viewing as {who}. Everything you do is recorded under their account with your name on it.
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={() => leaveGuarded(() => stopImpersonation())}
        sx={{
          textTransform: 'none',
          fontFamily: FONT,
          fontWeight: 600,
          color: '#FFFFFF',
          borderColor: '#FFFFFF',
          '&:hover': { borderColor: '#FFFFFF', bgcolor: 'rgba(255,255,255,0.12)' },
        }}
      >
        Exit impersonation
      </Button>
    </Box>
  );
}
